import { SimpleGrid } from "@chakra-ui/react";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { TbCalendarTime } from "react-icons/tb";
import colors from "core/resources/theme/colors";
import iconeCashClock from "assets/images/svgs/cash-clock.svg";
import { Image } from "@chakra-ui/react";
import { TotaisRelatorioReservas } from "features/relatorios/typings";
import { FiltroRelatorioReservas } from "core/features/relatorios/typings";
import Card1Horizontal from "components/Cards/Card1Horizontal";
import { StatusReservaEnum } from "core/features/reservas/typings";

interface DashboardRelatorioReservasProps {
  data?: TotaisRelatorioReservas | undefined;
  loading: boolean;
  filtro: FiltroRelatorioReservas;
  onChangeFiltro: (filtro: Partial<FiltroRelatorioReservas>) => any;
}

export default function DashboardRelatorioReservas({
  data,
  loading,
  filtro,
  onChangeFiltro,
}: DashboardRelatorioReservasProps) {
  const handleCardClick = (status: StatusReservaEnum) => {
    if (filtro.status === status) {
      return onChangeFiltro({ status: undefined });
    }
    return onChangeFiltro({ status });
  };

  return (
    <>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px" mb="32px">
        <Card1Horizontal
          selected={filtro.status === StatusReservaEnum.Confirmada}
          onClick={() => handleCardClick(StatusReservaEnum.Confirmada)}
          icon={<AiOutlineCheck size={25} color={colors.green} />}
          color={colors.green}
          bg={colors.green100}
          description="Confirmadas"
          title={data?.totalConfirmadas ? `${data?.totalConfirmadas}` : " 0"}
          loading={loading}
        />

        <Card1Horizontal
          selected={filtro.status === StatusReservaEnum.Pendente}
          onClick={() => handleCardClick(StatusReservaEnum.Pendente)}
          icon={<TbCalendarTime size={25} color={colors.orange} />}
          color={colors.orange}
          bg={colors.orange50}
          description="Pendentes"
          title={data?.totalPendentes ? `${data?.totalPendentes}` : " 0"}
          loading={loading}
        />

        <Card1Horizontal
          selected={filtro.status === StatusReservaEnum.AguardandoPagamento}
          onClick={() => handleCardClick(StatusReservaEnum.AguardandoPagamento)}
          icon={
            <Image src={iconeCashClock} h="24px" w="auto" mt="6px" ml="4px" />
          }
          color={colors.yellow}
          bg={colors.yellow50}
          description="Aguardando Pagamento"
          title={
            data?.totalAguardandoPagamento
              ? `${data?.totalAguardandoPagamento}`
              : " 0"
          }
          loading={loading}
        />

        <Card1Horizontal
          selected={filtro.status === StatusReservaEnum.Cancelada}
          onClick={() => handleCardClick(StatusReservaEnum.Cancelada)}
          icon={<AiOutlineClose fontSize="24px" color={colors.red} />}
          color={colors.red}
          bg={colors.red100}
          description="Canceladas"
          title={data?.totalCanceladas ? `${data?.totalCanceladas}` : " 0"}
          loading={loading}
        />
      </SimpleGrid>
    </>
  );
}
